import Vue from 'vue'
import VueRouter from 'vue-router'

import HomePage from "./components/HomePage"
import ItemDetail from "./components/ItemDetail"
import SearchResults from "./components/SearchResults"
import AboutUs from "./components/AboutUs"
import Article from "./components/Article"

Vue.use(VueRouter)

const routes = [
    {
        path: "/o-nas/",
        name: "aboutus",
        component: AboutUs,
        pathToRegexpOptions: { strict: true }
    },
    {
        path: "/szukaj/",
        name: "searchresults",
        component: SearchResults,
        pathToRegexpOptions: { strict: true }
    },
    {
        path: "/artykul/:slug/",
        name: "article",
        component: Article,
        pathToRegexpOptions: { strict: true }
    },
    {
        path: "/:slug/",
        name: "itemdetail",
        component: ItemDetail,
        pathToRegexpOptions: { strict: true }
    },
    {
        path: "/",
        name: "home",
        component: HomePage,
        pathToRegexpOptions: { strict: true }
    },
]

var router = new VueRouter(
    {
        mode: 'history',
        routes,
        scrollBehavior(to, from, savedPosition) {
            var position = { x: 0, y: 0 }
            if (savedPosition) {
                position = savedPosition
            }

            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(position)
                }, 250)
            })
        }


    })

export default router

